module.exports = __webpack_public_path__ + "img/fee4f8dee45ac1b3825a996f8ed52667.5ffc698d.jpg";